// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__FKtYE","active":"NavigationItem_active__2MiNG"};